import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export const queryNavigation = ( param, value ) => {
	const location = window.location;
	const queryParam = new URLSearchParams( location.search );
	queryParam.set( param, value );
	history.push( location.pathname + '?' + queryParam.toString() );
};

export const queryParamDelete = ( param ) => {
	const location = window.location;
	const queryParam = new URLSearchParams( location.search );
	queryParam.delete( param );
	history.push( location.pathname + '?' + queryParam.toString() );
};
